import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';


$(document).ready(function () {

    const lightbox = new PhotoSwipeLightbox({
        gallery: '.works-detail__gallery',
        children: 'a',
        zoom: false,
        initialZoomLevel: 'fit',
        showHideAnimationType: 'fade',
        secondaryZoomLevel: 'fit',
        pswpModule: PhotoSwipe
    });

    $('.works-detail__gallery .works-detail__image').each(function (callback) {
        // $('.wp-block-gallery').attr('id', 'project-gallery');
        var $img = $(this).find('img'),
            $isSrc = $img.attr('src');

        if (!$img.closest('a').length) {
            $(this).wrap('<a href="' + $isSrc + '" data-pswp-srcset="' + $isSrc + '" data-pswp-width="960" data-pswp-height="960" target="_blank"></a>');
        }
    }, lightbox.init());


});
